export default "__VITE_ASSET__0b81920f__"